import { sessionStorage } from "./globals";

export function getUserLanguage() {
  return sessionStorage.getItem("user-language");
}
